module.exports = __webpack_public_path__ + "img/photo-29.c24033fb.jpg";